<div class="container-fluid pb-0" *ngIf="project">
    <div class="row">
        <div class="col-md-12">

            <div class="row">
                <div class="info-container col-md-12 pt-3 pb-2">
                    <h1 class="mb-0 txt-primary">
                        {{project.title}}
                    </h1>
                    <small class="ml-2">({{project.shortDescription}})</small>
                    <i class="far fa-times-circle pt-1" (click)="closeSideBar()"></i>
                </div>
            </div>
            <br>
            <div class="description">
                <div class="text-center">
                    <img [src]="project.imgSrc" [alt]="project.title" style="width: 90%; height: auto;"
                    [class]="project.class" [ngClass]="{ 'padtop' : project.class }">
                </div>
                <div class="chips-container py-3" *ngIf="project.technologies.length !== 0">
                    <mat-chip-list aria-label="technologies">
                        <mat-chip style="width: 0; height: 0; opacity: 0; margin: 0; padding: 0;"></mat-chip>
                        <mat-chip *ngFor="let tech of project.technologies"> {{ tech }} </mat-chip>
                    </mat-chip-list>
                </div>
                <div class="description-container">
                    {{ project.description }}
                </div>
                <br>
            </div>

        </div>
    </div>
</div>